import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { IGenericContent } from "./igeneric-content";


@Injectable({ providedIn: 'root' })
export class GenericContentService {

    private _genericContent: BehaviorSubject<IGenericContent | null> = new BehaviorSubject<IGenericContent | null>(null);
    private _genericContents: BehaviorSubject<IGenericContent[]> = new BehaviorSubject<IGenericContent[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get genericContetnt$(): Observable<IGenericContent | null> {
        return this._genericContent.asObservable();
    }

    get genericContetnts$(): Observable<IGenericContent[]> {
        return this._genericContents.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getAllGenericContent(genericContentData: PaginationRequest): Observable<BaseRespone<{ pagination: PaginationResult; genericContentDetails: IGenericContent[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; genericContentDetails: IGenericContent[] }>>(`${environment.baseURl}/Drug/GenericContentList`, genericContentData).pipe(
            tap((response) => {
                this._pagination.next(response.result.pagination);
                this._genericContents.next(response.result.genericContentDetails);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createGenericContetnt(genericContent: IGenericContent): Observable<BaseRespone<IGenericContent>> {
        return this._httpClient.post<BaseRespone<IGenericContent>>(`${environment.baseURl}/Drug/GenericContent`, genericContent)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newgenericContent) => {
                    // Return the new patients
                    return newgenericContent;
                })
            )
    }

    deleteGenericContetnt(id: number): Observable<BaseRespone<boolean>> {
        return this.genericContetnts$.pipe(
            take(1),
            switchMap(patient =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/Drug/GenericContent/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {
                            const GenericContetnt = patient.filter(item => item.id !== id);
                            this._genericContents.next(GenericContetnt);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                return of(error.error);
            })
        );
    }

    updateGenericContetnt(GenericContetnt: IGenericContent): Observable<BaseRespone<IGenericContent>> {
        return this.genericContetnts$.pipe(
            take(1),
            switchMap(GenericContetnts => this._httpClient.put<BaseRespone<IGenericContent>>(`${environment.baseURl}/Drug/GenericContent`, GenericContetnt).pipe(
                map((updated: BaseRespone<IGenericContent>) => {

                    // Find the index of the updated product
                    const index = GenericContetnts.findIndex(item => item.id === GenericContetnt.id);

                    // Update the product
                    GenericContetnts[index] = GenericContetnt;

                    // Update the products
                    this._genericContents.next(GenericContetnts);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

}